import type { EntityId, GoodsSku, GoodsSpec } from "@/types/shopGoods";

// 根据规格项身份保留对应值，移除中间规格项时不把后续值错配到别的维度。
export function remapSkuSpecifications(skus: GoodsSku[], previous: GoodsSpec[], next: GoodsSpec[]): GoodsSku[] {
  return skus.map((sku) => {
    const ids = (sku.skuSpecValueIds ?? "").split(",");
    return {
      ...sku,
      skuSpecValueIds: next.map((spec) => {
        const index = previous.findIndex((item) => String(item.specId) === String(spec.specId));
        return index < 0 ? "" : ids[index] ?? "";
      }).join(","),
    };
  });
}
export function setSkuSpecificationValue(current: string | undefined, index: number, id: EntityId | undefined, count: number): string {
  const ids = (current ?? "").split(",");
  return Array.from({ length: count }, (_, position) => position === index ? String(id ?? "") : ids[position] ?? "").join(",");
}
